// Draft utility functions for saving and loading form data
export const DRAFT_KEYS = {
  // PreOperative forms
  CONFIRMATION_PHASE: 'confirmation_phase_draft',
  SURGICAL_SAFETY_CHECKLIST: 'surgical_safety_checklist_draft',
  PREOPERATIVE_ORDERS: 'preoperative_orders_draft',
  CONSENT_FOR_ANAESTHESIA: 'consent_for_anaesthesia_draft',
  CONSENT_FOR_MEDICAL: 'consent_for_medical_draft',
  PRE_ANAESTHETIC_FORM: 'pre_anaesthetic_form_draft',
  PRE_ANAESTHETIC_EVALUATION: 'pre_anaesthetic_evaluation_draft',
  HIGH_RISK_CONSENT: 'high_risk_consent_draft',
  PREOPERATIVE_CHECKLIST: 'preoperative_checklist_draft',
  CONSIDERATION_PHASE: 'consideration_phase_draft',
  
  // IntraOperative forms
  OPERATION_SHEET: 'operation_sheet_draft',
  INTRAOPERATIVE_NURSING_RECORD: 'intraoperative_nursing_record_draft',
  
  // PostOperative forms
  POST_OPERATIVE_INSTRUCTIONS: 'post_operative_instructions_draft',
  POST_OPERATIVE_ANALGESIA_ASSESSMENT: 'post_operative_analgesia_assessment_draft',
  POST_OPERATIVE_ORDERS: 'post_operative_orders_draft',
  
  // Other forms
  ADD_PATIENT: 'add_patient_draft',
  ADD_OT_BOOKING: 'add_ot_booking_draft',
  ADD_USER: 'add_user_draft',
  ADD_INVENTORY: 'add_inventory_draft',
  EDIT_PATIENT: 'edit_patient_draft',
  EDIT_OT_BOOKING: 'edit_ot_booking_draft',
  EDIT_USER: 'edit_user_draft',
  EDIT_INVENTORY: 'edit_inventory_draft',
  ADD_PATIENT_FEEDBACK: 'add_patient_feedback_draft'
};

// Save draft data to localStorage
export const saveDraft = (formKey, uhidNo, formData) => {
  try {
    const draftKey = `${formKey}_${uhidNo}`;
    const draftData = {
      formData,
      timestamp: new Date().toISOString(),
      uhidNo
    };
    localStorage.setItem(draftKey, JSON.stringify(draftData));
    return true;
  } catch (error) {
    console.error('Error saving draft:', error);
    return false;
  }
};

// Load draft data from localStorage
export const loadDraft = (formKey, uhidNo) => {
  try {
    const draftKey = `${formKey}_${uhidNo}`;
    const draftData = localStorage.getItem(draftKey);
    if (draftData) {
      return JSON.parse(draftData);
    }
    return null;
  } catch (error) {
    console.error('Error loading draft:', error);
    return null;
  }
};

// Clear draft data from localStorage
export const clearDraft = (formKey, uhidNo) => {
  try {
    const draftKey = `${formKey}_${uhidNo}`;
    localStorage.removeItem(draftKey);
    return true;
  } catch (error) {
    console.error('Error clearing draft:', error);
    return false;
  }
};

// Check if draft exists
export const hasDraft = (formKey, uhidNo) => {
  try {
    const draftKey = `${formKey}_${uhidNo}`;
    return localStorage.getItem(draftKey) !== null;
  } catch (error) {
    console.error('Error checking draft:', error);
    return false;
  }
};

// Get all drafts for a specific UHID
export const getAllDraftsForUHID = (uhidNo) => {
  try {
    const drafts = [];
    Object.values(DRAFT_KEYS).forEach(key => {
      const draft = loadDraft(key, uhidNo);
      if (draft) {
        drafts.push({
          formKey: key,
          timestamp: draft.timestamp,
          uhidNo: draft.uhidNo
        });
      }
    });
    return drafts;
  } catch (error) {
    console.error('Error getting all drafts:', error);
    return [];
  }
};

// Clear all drafts for a specific UHID
export const clearAllDraftsForUHID = (uhidNo) => {
  try {
    Object.values(DRAFT_KEYS).forEach(key => {
      clearDraft(key, uhidNo);
    });
    return true;
  } catch (error) {
    console.error('Error clearing all drafts:', error);
    return false;
  }
};

// Get draft age in hours
export const getDraftAge = (draft) => {
  if (!draft || !draft.timestamp) return 0;
  const draftTime = new Date(draft.timestamp);
  const now = new Date();
  return (now - draftTime) / (1000 * 60 * 60); // hours
};

// Check if draft is older than 24 hours
export const isDraftExpired = (draft) => {
  return getDraftAge(draft) > 24;
};
